import type {ReactiveController, ReactiveControllerHost} from 'lit';

type TouchPredicate = (host: ReactiveControllerHost) => boolean;
type TouchCallback = (host: ReactiveControllerHost) => void;

export class TouchController implements ReactiveController {
  host: ReactiveControllerHost;
  touched = false;

  private predicate: TouchPredicate;
  private callback?: TouchCallback;

  constructor(
    host: ReactiveControllerHost,
    {
      predicate,
      callback,
    }: {
      predicate: TouchPredicate;
      callback?: TouchCallback;
    }
  ) {
    (this.host = host).addController(this);
    this.predicate = predicate;
    this.callback = callback;
  }

  hostUpdated(): void {
    if (this.predicate(this.host) && !this.touched) {
      this.touched = true;
      this.callback?.(this.host);
      this.host.requestUpdate();
    }
  }
}
